import { render, staticRenderFns } from "./ClariveinPage.vue?vue&type=template&id=7be925a0&scoped=true"
import script from "./ClariveinPage.vue?vue&type=script&lang=js"
export * from "./ClariveinPage.vue?vue&type=script&lang=js"
import style0 from "./ClariveinPage.vue?vue&type=style&index=0&id=7be925a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be925a0",
  null
  
)

export default component.exports